import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Route, Link } from 'react-router';
import moment from 'moment';
import Moment from 'react-moment';
import { HTTP } from 'meteor/http';

import {
  Well,
  Table,
  Button,
  BPanel,
  Col,
  FormControl,
  FormGroup
} from '@sketchpixy/rubix';
var DatePicker = require("react-bootstrap-date-picker");
import { Flights } from '../../collections/flights/flights';
import { Reactive } from '../common/Reactive.mixin.js';
import { Reservations } from '../../collections/reservations/reservations';
import { Montgolfieres } from '../../collections/montgolfieres/montgolfieres';
import { Base64 } from 'meteor/base64';

@Reactive({
	subscriptions: [{name: 'flight', param: 'id'}],
})
export default class FlightDetailPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	openPopUp(urlToOpen) {
	  var popup_window=window.open(urlToOpen,"myWindow","toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=400, height=400");
	  try {
	    popup_window.focus();
	  }
	  catch (e) {
	    alert("Les fenêtes Pop-up sont bloquées ! Pour télécharger ce document, merci de les débloquer.");
	  }
	}

  downloadDDV() {
		let flight = this.state.flight;
        let reservations = Reservations.find({_id: {$in: flight.reservationIds }}, {fields: {"id_billet": 1, "passengers": 1, "payment": 1}}).fetch();

        _.each(reservations, (reservation) => {
            reservation.passengers = reservation.getPassengers();
            console.log('getPassengers', reservation.getPassengers());
            reservation.payementMode = reservation.getPayment();
        });

				let selectedMontgolfiere = Montgolfieres.findOne(flight.montgolfiereId);
				let montgolfieresDatas = Montgolfieres.find({ $or: [{online: true}, {_id: flight.montgolfiereId}]}).fetch()

				let montgolfieres = [];
				_.each(montgolfieresDatas, (montgolfiere) => {
					montgolfieres.push({
						'maxWeight': montgolfiere.maxWeight,
						'defaultWeight': montgolfiere.defaultWeight,
						'emptyWeight': montgolfiere.emptyWeight,
						'name' : montgolfiere.name,
						'archived': montgolfiere.archived
					});
				});

				let pilote = Meteor.users.findOne(flight.pilotId);

        let data = {
            montgolfieres : montgolfieres,
            selectedMontgolfiere : {
							'defaultWeight': selectedMontgolfiere.defaultWeight,
							'maxWeight': selectedMontgolfiere.maxWeight,
							'name': selectedMontgolfiere.name,
						},
            reservations : reservations,
            temp : flight.temp,
            date: moment(flight.date).format('DD/MM/YYYY'),
            period: flight.period,
            place: flight.place,
            pilote: {
							'firstName': pilote.profile.firstName,
							'lastName': pilote.profile.lastName,
							'weight': pilote.profile.weight,
						},
            meetPoint: flight.getMeetPoint(),
            meetingDate: moment(flight.meetingDate).format('HH:mm')
        }

        console.log('data', data);

		HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=vol', {
		  data
		}, (error, result) => {
			result = JSON.parse(result.content);
			this.openPopUp("https://montgolfieres-pdf.amaia.at/" + result.id + ".pdf");
		});

    }


	componentWillReceiveProps(nextProps) {
		if (nextProps.isReady && !this.props.isReady) {
			this.setState({
				flight: Flights.findOne({_id: this.props.params.id})
			});

			console.log('flight', Flights.findOne({_id: this.props.params.id}).getReservations());
		}
	}


	render() {

		if(!this.state.flight) {
			return (<div>Chargement...</div>);
		}

		return (

				<div>
					<BPanel header={"Vol du " + moment(this.state.flight.date).format('DD/MM/YYYY') + " le " + this.state.flight.getPeriod()}>
						<Table striped bordered condensed hover>
							<tbody>
								<tr>
									<td>Date</td>
									<td>{moment(this.state.flight.date).format('DD/MM/YYYY')}</td>
								</tr>
								<tr>
									<td>Période</td>
									<td>{this.state.flight.getPeriod()}</td>
								</tr>
								<tr>
									<td>Lieu d'envol</td>
									<td>{this.state.flight.getPlace()}</td>
								</tr>
								<tr>
									<td>Status</td>
									<td>{this.state.flight.getStatus()}</td>
								</tr>
								{this.state.flight.getPilote() &&
									<tr>
										<td>Pilote</td>
										<td>{this.state.flight.getPilote().displayName()}</td>
									</tr>
								}
								{this.state.flight.getMontgolfiere() &&
									<tr>
										<td>Montgolfiere</td>
										<td>{this.state.flight.getMontgolfiere().name}</td>
									</tr>
								}
								<tr>
									<td>Réservations</td>
									<td>
										{this.state.flight.getReservations().map((reservation) => {
											return (
												<tr>
													<td><Link to={'reservations/' + reservation._id}>Reservation n° {reservation.id_billet}</Link></td>
												</tr>
											);
										})}
									</td>
								</tr>
							</tbody>
						</Table>
						<Table striped bordered condensed hover>
							<tbody>
								{this.state.flight.meetingDate &&
									<tr>
										<td>Heure de rendez-vous</td>
										<td>
											{moment(this.state.flight.meetingDate).format('HH:mm')}
										</td>
									</tr>
								}
								{this.state.flight.getMeetPoint() &&
									<tr>
										<td>Lieu de rendez-vous</td>
										<td>
											{this.state.flight.getMeetPoint().name}
										</td>
									</tr>
								}
							</tbody>
						</Table>
						<Table striped bordered condensed hover>
							<tbody>
								{this.state.flight.takeOffDate &&
									<tr>
										<td>Heure de décollage</td>
										<td>
											{moment(this.state.flight.takeOffDate).format('HH:mm')}
										</td>
									</tr>
								}
								{this.state.flight.landingDate &&
									<tr>
										<td>Heure d'atterrissage</td>
										<td>
											{moment(this.state.flight.landingDate).format('HH:mm')}
										</td>
									</tr>
								}
								{this.state.flight.time &&
									<tr>
										<td>Durée du vol</td>
										<td>
											{Math.abs(this.state.flight.time) + 'mn'}
										</td>
									</tr>
								}
								{this.state.flight.takeOffPlace &&
									<tr>
										<td>Lieu de décollage</td>
										<td>
											{this.state.flight.takeOffPlace}
										</td>
									</tr>
								}
								{this.state.flight.landingPlace &&
									<tr>
										<td>Lieu d'atterrissage</td>
										<td>
											{this.state.flight.landingPlace}
										</td>
									</tr>
								}
                <tr>
                  <td>Dossier de vol</td>
                  <td><Button bsStyle="info" onClick={::this.downloadDDV}>Télécharger</Button></td>
                </tr>
							</tbody>
						</Table>
						<br/>
					</BPanel>
				</div>
			   );
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/FlightDetail.page.js
 **/